import { setItemSessionStorage } from '@at/window-utils'
import { SessionKeys } from './session-keys'
import { uuidProvider } from '../pages/search-results/uuid-provider'

export const setSearchId = () => {
    setItemSessionStorage(SessionKeys.SEARCH_ID, uuidProvider.getUUID())
}
